import { render, staticRenderFns } from "./funding-card.vue?vue&type=template&id=6cda0252&scoped=true"
import script from "./funding-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./funding-card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./funding-card.vue?vue&type=style&index=0&id=6cda0252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cda0252",
  null
  
)

export default component.exports